import { connect } from 'react-redux';
import { compose } from 'redux';
import injectSaga from 'utils/injectSaga';
import injectReducer from 'utils/injectReducer';
import saga from './saga';
import reducer from './reducer';
import { fetchContentRequest } from './actions';
import { LAYOUT_PREVIEW_KEY } from './constants';
import ContentfulPreview from './ContentfulPreview';

const mapDispatchToProps = {
  fetchContent: fetchContentRequest,
};

const mapStateToProps = (state) => ({
  preview: state.get(LAYOUT_PREVIEW_KEY).toJS(),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withReducer = injectReducer({ key: LAYOUT_PREVIEW_KEY, reducer });

const withSaga = injectSaga({
  key: LAYOUT_PREVIEW_KEY,
  saga,
});

export default compose(withReducer, withConnect, withSaga)(ContentfulPreview);
